import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent, updateApplicant, updateCurrentScreen, updateApplicantStatus } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import {
    selectApplicationCompletionData,
    selectApplicationCompletionStatus,
    selectApplicationCompletionError,
    initializeAsync,
} from "./applicationCompletionSlice";
import { Button, Container, Typography } from "@mui/material";
import SuccessGif from "../../assets/gif/5de.gif";
import ErrorGif from "../../assets/gif/sad-face-emoji.gif";
import ProcessingGif from "../../assets/gif/giphy.gif";
import { useNavigate } from "react-router-dom";

import { ReactComponent as ApplicationSubmitted } from "../../assets/svgs/application-submitted.svg";

// Add custom imports here

const ApplicationCompletion = () => {
    const data = useSelector(selectApplicationCompletionData);
    const status = useSelector(selectApplicationCompletionStatus);
    const error = useSelector(selectApplicationCompletionError);
    const dispatch = useDispatch();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync, logoutWithoutNavigate } = useAuth();
    let userDetails = getUserDetailsNotAsync();

    // Add Variables

    const [pageStatus, setPageStatus] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
            window.gtag("event", "conversion", { "send_to": "AW-335725506/nQLQCM_p14ADEMKHi6AB" });
            const query = new URLSearchParams(window.location.search);
            const paymentIntent = query.get("payment_intent");
            const paymentIntentClientSecret = query.get("payment_intent_client_secret");
            const redirectStatus = query.get("redirect_status");
            const amount = query.get("amount");
            const promocode = query.get("promocode");
            let completion = false;
            if (!userDetails?.applicant?.primaryApplicant) {
                setPageStatus({
                    icon: SuccessGif,
                    redirectStatus: redirectStatus,
                    heading: "Thanks for submitting your application!",
                    subheading:
                        "Applications are processed in the order in which they are received. We will process your application and notify you of the results within 2 business days. You can login to the Pathway portal to check the status of your application. Congrats on this step towards homeownership.",
                });
                completion = true;
            } else if (redirectStatus && paymentIntentClientSecret) {
                switch (redirectStatus) {
                    case "succeeded":
                        console.log("Payment succeeded!");
                        setPageStatus({
                            icon: SuccessGif,
                            redirectStatus: redirectStatus,
                            heading: "Thanks for submitting your application!",
                            subheading:
                                "Applications are processed in the order in which they are received. We will process your application and notify you of the results within 2 business days. You can login to the Pathway portal to check the status of your application. Congrats on this step towards homeownership.",
                        });
                        completion = true;
                        break;
                    case "processing":
                        setPageStatus({
                            icon: ProcessingGif,
                            redirectStatus: redirectStatus,
                            heading: "Your payment is processing!",
                            subheading:
                                "Thanks for submitting your application. We will review your application and notify you of the results within 2 business days",
                        });
                        completion = true;
                        break;
                    case "requires_payment_method":
                        setPageStatus({
                            icon: ErrorGif,
                            redirectStatus: redirectStatus,
                            heading: "Your payment was not successful, please try again.",
                            subheading: "Go back to the payment screen and try again",
                            displayBackButton: true,
                        });
                        break;
                    default:
                        setPageStatus({
                            icon: ErrorGif,
                            redirectStatus: redirectStatus,
                            heading: "Your payment was not successful, please try again.",
                            subheading: "Go back to the payment screen and try again",
                            displayBackButton: true,
                        });
                        break;
                }
                let applicant = userDetails.applicant;
                applicant.paymentIntent = paymentIntent;
                applicant.paymentIntentClientSecret = paymentIntentClientSecret;
                applicant.redirectStatus = redirectStatus;
                applicant.amount = amount;
                applicant.promocode = promocode;
            } else {
                setPageStatus({
                    icon: SuccessGif,
                    redirectStatus: redirectStatus,
                    heading: "Thanks for submitting your application!",
                    subheading:
                        "Applications are processed in the order in which they are received. We will process your application and notify you of the results within 2 business days. You can login to the Pathway portal to check the status of your application. Congrats on this step towards homeownership.",
                });
                completion = true;
            }

            if (completion) {
                setTimeout(() => {
                    logoutWithoutNavigate();
                }, 5000);
            }
        } else {
            setPageStatus({
                icon: SuccessGif,
                redirectStatus: "",
                heading: "Thanks for submitting your application!",
                subheading:
                    "Applications are processed in the order in which they are received. We will process your application and notify you of the results within 2 business days. You can login to the Pathway portal to check the status of your application. Congrats on this step towards homeownership.",
            });
        }
    }, []);

    const handleBack = () => {
        navigate("/application/application-Payment/payment", {
            replace: true,
        });
    };

    let body = (
        <>
            {pageStatus && (
                <Container sx={{ backgroundColor: "white", textAlign: "center" }}>
                    {/* <img src={pageStatus.icon} alt={pageStatus.redirectStatus} style={{ width: "100px" }}></img> */}
                    <ApplicationSubmitted style={{ width: "200px" }}></ApplicationSubmitted>
                    <Typography variant="h1" component="h1">
                        {pageStatus.heading}
                    </Typography>
                    <Typography variant="h6" component="h6" sx={{ textAlign: "center" }}>
                        {pageStatus.subheading}
                    </Typography>
                    {pageStatus.displayBackButton && (
                        <Button
                            onClick={() => handleBack()}
                            color="primary"
                            variant="contained"
                            sx={{ height: "45px" }}>
                            Go back to payment
                        </Button>
                    )}
                </Container>
            )}
        </>
    );

    return getPageContent(body, status, error);
};

export { ApplicationCompletion };
